import { getInitialStateFromConfig } from "helpers/form";
import { numberInRange } from "helpers/validators";

const config = {
    allowableDistanceFromLastBidPoint: {
        // field
        label: "Расстояние от точки выгрузки до машины (км)",
        validators: [(value) => (value ? numberInRange(value, 10, 100) : "")],
        inputProps: {
            name: "allowableDistanceFromLastBidPoint",
            type: "number",
            placeholder: "от 10 до 100",
            step: "1",
            min: 10,
            max: 100,
        },
    },
    updateFrequency: {
        // field
        label: "Частота обновления (мин)",
        validators: [(value) => (value ? numberInRange(value, 5, 60) : "")],
        inputProps: { name: "updateFrequency", type: "number", placeholder: "от 5 до 60", step: "1", min: 5, max: 60 },
    },
};

const initialState = getInitialStateFromConfig(config);

export { config, initialState };
